<template>
  <div :class="this.$isPC ? 'wrapper-heading' : 'sp-wrapper-heading'">
    <img src="/static/header/banner.jpg" class="wrapper-heading-image" />
    <h1 class="wrapper-heading-title">
      {{ title }}
    </h1>
    <sp-phone-contact v-if="!this.$isPC" />
  </div>
</template>

<script>
import SpPhoneContact from '@/components/modules/campaign/SpPhoneContact'

export default {
  props: ['title'],
  components: {
    SpPhoneContact,
  },
}
</script>

<style scoped>
.wrapper-heading,
.sp-wrapper-heading {
  position: relative;

  width: 100%;
}

.sp-wrapper-heading {
  margin-bottom: 10px;
}

.wrapper-heading-image {
  width: 100%;
  height: auto;
  margin-bottom: 35px;
}

.sp-wrapper-heading .wrapper-heading-image {
  height: 96px;
  margin-bottom: 0;

  object-position: 80% 100%;
  object-fit: cover;
}

.wrapper-heading-title {
  font-size: 22px;
  font-weight: bold;

  position: absolute;
  bottom: 50%;
  left: 15%;
  margin: 0;
}

.sp-wrapper-heading .wrapper-heading-title {
  top: 20%;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/HeaderBanner.vue